import actionTypes from "../action-types";

export function initialiseSelectedChildAction(
  userId: string | null | undefined
) {
  return {
    type: actionTypes.INITIALISE_SELECTED_CHILD,
    payload: {
      userId
    }
  };
}

export function updateChildUserId(userId: string | null | undefined) {
  return {
    type: actionTypes.SET_CHILD_USER_ID,
    payload: {
      userId
    }
  };
}

export function updateStartTime(startTime: string) {
  return {
    type: actionTypes.SET_START_TIME,
    payload: {
      startTime
    }
  };
}

export function updateEndTime(endTime: string) {
  return {
    type: actionTypes.SET_END_TIME,
    payload: {
      endTime
    }
  };
}

type TimePeriod = {
  startTime: string;
  endTime: string;
};

export function updateSelectedTimePeriod({ startTime, endTime }: TimePeriod) {
  return {
    type: actionTypes.SET_TIME_PERIOD,
    payload: {
      startTime,
      endTime
    }
  };
}
